import actions from './actions';
const initState = {
    wifiActivationLoading: false,
    wifiActivationMessage: null,
    wifiActivationError: null,

    cancelWifiActivationLoading: false,
    cancelWifiActivationMessage: null,
    cancelWifiActivationError: null,
}

export default function reducer(state = initState, action) {
    switch (action.type) {
        case actions.WIFI_ACTIVATION:
            return {
                ...state,
                wifiActivationLoading: true,
                wifiActivationMessage: null,
                wifiActivationError: null,
            };
        case actions.WIFI_ACTIVATION_SUCCESS:
            return {
                ...state,
                wifiActivationLoading: false,
                wifiActivationMessage: action.payload.message,
                wifiActivationError: null,
            };
        case actions.WIFI_ACTIVATION_FAILED:
            return {
                ...state,
                wifiActivationLoading: false,
                wifiActivationMessage: null,
                wifiActivationError: action.payload.error,

            };

        case actions.CANCEL_WIFI_ACTIVATION:
            return {
                ...state,
                cancelWifiActivationLoading: true,
                cancelWifiActivationMessage: null,
                cancelWifiActivationError: null,
            };
        case actions.CANCEL_WIFI_ACTIVATION_SUCCESS:
            return {
                ...state,
                cancelWifiActivationLoading: false,
                cancelWifiActivationMessage: action.payload.message,
                cancelWifiActivationError: null,
            };
        case actions.CANCEL_WIFI_ACTIVATION_FAILED:
            return {
                ...state,
                cancelWifiActivationLoading: false,
                cancelWifiActivationMessage: null,
                cancelWifiActivationError: action.payload.error,

            };

        case actions.RESET_MESSAGE:
            return {
                ...state,
                wifiActivationMessage: null,
                wifiActivationError: null,
                cancelWifiActivationMessage: null,
                cancelWifiActivationError: null,
            };

        default:
            return state;
    }
}